// extracted by mini-css-extract-plugin
export default {"name":"ProjectUpdater_name__65Jsy"};